import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { filterBanksForDropdown, settingIsOn } from 'src/app/util/bank-usage.util';

@Component({
  selector: 'app-topup-modal',
  templateUrl: './topup-modal.component.html',
  styleUrls: ['./topup-modal.component.scss']
})
export class TopupModalComponent {

  @Input() set playerUUID(v:any) {
    this.player_uuid = v;
    this.init()
  }
  @Output() closeEvent = new EventEmitter<any>();
  public player_uuid:any;
  public data:any = {};
  public setting:any = {};
  public is_loading:boolean = false;
  public player:any = {};
  public referral_rate:any = 0;
  public banks:any = [];
  public player_banks:any = [];
  public current_company:any = {}
  public is_loading_function:boolean = false;


  constructor(private http: HttpService) {
    this.current_company = this.http.getSelecetdCompanyDetail()
    this.companySetting();
  }

  async companySetting() {
    let y:any = await this.http.post("/admin/company/setting");
    this.setting = y.setting;
  }

  async init() {
    this.is_loading = true;
    let y:any = await this.http.post("/admin/player/get/v2", {player_uuid: this.player_uuid})

    this.player = y;
    this.data.player_game_id = null;
    this.data.game_id = null;
    this.data.player_uuid = this.player_uuid;

    this.getBankDetail();
   this.referral_rate = parseFloat(this.player.referral_rate ?? this.current_company.referral_rate);
  }

  async getBankDetail() {
    let y:any = await this.http.post("/admin/player/bank-detail", {...this.data, usage: 'deposit'})

    // Opt-in per company: hide "Do Not Show" (public=0) banks from the dropdown. Default OFF.
    const hideNonPublic = settingIsOn(this.setting && this.setting.panel_hide_nonpublic_banks);
    this.banks = filterBanksForDropdown(y.banks || [], 'deposit', hideNonPublic);
    this.player_banks = y.player_banks;

  }


  topupValueChange() {
    this.data.referral_commission = (this.data.amount * this.referral_rate) / 100;

    if(this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.point = (this.data.amount * parseFloat(this.setting.credit_calculation_rate)) / 100;
    }

  }


  topupOnlyChange() {
    delete this.data.amount;
    delete this.data.deposit_bank;
    delete this.data.point;
  }

  async topup() {

    if((!this.data.amount || this.data.amount <= 0) && !this.data.bonus) {
      this.data.amount = null;
      this.http.notify("Deposit Account or bonus be empty")
      return;
    }

    if(!this.data.deposit_bank && !this.data.topup_only) {
      this.http.notify("Select Deposit Account")
      return;
    }

    this.is_loading_function = true;

    this.data.player_uuid = this.player_uuid;

    let z:any = await this.http.post("/admin/promotion/validate-deposit", this.data);

    if(!z.status) {
      this.http.toast("There are active promotions and existing balance will be forfited. You are required to cancel the promotion first.", "error");
      this.is_loading_function = false;
      return;
    }

    let y:any = await this.http.post("/admin/wallet/topup", this.data);
    this.is_loading_function = false;

    if(!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    this.close("Deposit: " + this.data.amount + "\nBonus: " + this.data.bonus + "\n")

    
  }

  close(val:any = false) {
    this.closeEvent.emit(val)
  }
}
